export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const GET_USER = "GET_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const PAYMENT_SUCCESSFUL = "PAYMENT_SUCCESSFUL";

//Messages
export const OPEN = "OPEN";
export const IDENTITY = "IDENTITY";
export const RECENT_CHAT = "RECENT_CHAT";
export const CHAT_HISTORY = "CHAT_HISTORY";
export const SELECTED_CHAT = "SELECTED_CHAT";
export const CHAT_SENT_ACK = "CHAT_SENT_ACK";
export const USER_ONLINE = "USER_ONLINE";
export const GET_GIF = "GET_GIF";
export const GET_DETAILED_GIF = "GET_DETAILED_GIF";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const START_TYPING_ACK = "START_TYPING_ACK";
export const STOP_TYPING_ACK = "STOP_TYPING_ACK";
export const CHAT_RECEIVED = "CHAT_RECEIVED";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const IS_USER_ONLINE = "IS_USER_ONLINE";
export const READ_ALL_MESSAGES = "READ_ALL_MESSAGES";
export const BUSINESS_CHAT_RECEIVED = "BUSINESS_CHAT_RECEIVED";
export const BUSINESS_CHAT_HISTORY = "BUSINESS_CHAT_HISTORY";
export const BUSINESS_DELETE_MESSAGE = "BUSINESS_DELETE_MESSAGE";
export const ERROR = "ERROR";
export const INITIAL_LOAD = "INITIAL_LOAD";
export const HIDE_POP_UP = "HIDE_POP_UP";
export const DELETE_CHAT = "DELETE_CHAT";
export const SET_SCROLL = "SET_SCROLL";
export const UNREAD_COUNT = "UNREAD_COUNT";
export const CLEAR_GIF = "CLEAR_GIF";
export const INCREASE_MESSAGE_INDEX = "INCREASE_MESSAGE_INDEX";
export const UPDATE_RECENT_CHAT = "UPDATE_RECENT_CHAT";
export const GET_DIALOG = "GET_DIALOG";
export const REMOVE_EMPTY_DIALOG = "REMOVE_EMPTY_DIALOG";
export const UNSELECT_CHAT = "UNSELECT_CHAT";
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const TOGGLE_POPUP = "TOGGLE_POPUP";
export const ADD_TOAST = "ADD_TOAST";
export const ON_CLICK_TOAST = "ON_CLICK_TOAST";
//EVENTS
export const CREATE_EVENT = "CREATE_EVENT";
export const FETCH_EVENTS = "FETCH_EVENTS";
export const REFETCH_EVENTS = "REFETCH_EVENTS";
export const REFETCH_OWNEVENTS = "REFETCH_OWNEVENTS";
export const FETCH_OWN_EVENTS = "FETCH_OWN_EVENTS";
export const DELETE_EVENT = "DELETE_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";

//deals
export const GET_DEAL = "GET_DEAL";
export const CREATE_DEAL = "CREATE_DEAL";
export const GET_POTENTIAL_COUNT = "GET_POTENTIAL_COUNT";
export const DELETE_DEAL = "DELETE_DEAL";

//post
export const ADD_POST = "ADD_POST";
export const GET_POST = "GET_POST";
export const DELETE_POST = "DELETE_POST";
export const UPDATE_POST = "UPDATE_POST";
export const EMPTY_LIST = "EMPTY_LIST";

//album
export const ENABLE = "ENABLE";
export const DISABLE = "DISABLE";
export const GET_ALBUM = "GET_ALBUM";
export const ADD_ALBUM = "ADD_ALBUM";
export const UPDATE_DEAL = "UPDATE_DEAL";
export const DELETE_USEROWNFEED = "DELETE_USEROWNFEED";

//rewards
export const GET_REWARDS = "GET_REWARDS";

//Overview
export const GET_VISITORS = "GET_VISITORS";
export const GET_ACTIVITY = "GET_ACTIVITY";
export const UPDATE_VISIT = "UPDATE_VISIT";
export const GET_CHECKIN_DETAIL = "GET_CHECKIN_DETAIL";
export const GET_DEAL_CLAIMED_DETAIL = "GET_DEAL_CLAIMED_DETAIL";

//heatspot
export const GET_PARTICIPANTS = "GET_PARTICIPANTS";
export const GET_HERE_NOW = "GET_HERE_NOW";
export const CHANGE_PROFILE_IMAGE = "CHANGE_PROFILE_IMAGE";
export const CHANGE_COVER_IMAGE = "CHANGE_COVER_IMAGE";
export const ALL_LIVE_CHAT = "ALL_LIVE_CHAT";
export const LIVE_CHAT_SENT_MESSAGE_ACK = "LIVE_CHAT_SENT_MESSAGE_ACK";
export const LIVE_CHAT_REMOVE_BUSINESS_MESSAGE =
  "LIVE_CHAT_REMOVE_BUSINESS_MESSAGE";
export const LIVE_CHAT_UPDATE_RECENT_CHAT = "LIVE_CHAT_UPDATE_RECENT_CHAT";
export const HIDE_LIVE_CHAT_POP_UP = "HIDE_LIVE_CHAT_POP_UP";
export const SCROLL_LIVE_CHAT = "SCROLL_LIVE_CHAT";
export const INCREASE_LIVE_CHAT_INDEX = "INCREASE_LIVE_CHAT_INDEX";
export const EMPTY_BACKUP_CHAT = "EMPTY_BACKUP_CHAT";
export const EMPTY_LIVE_CHAT = "EMPTY_LIVE_CHAT";

//myAccount
export const GET_PROFILE = "GET_PROFILE";
export const CANCEL_PLAN = "CANCEL_PLAN";
export const GET_ACCOUNT_DETAIL = "GET_ACCOUNT_DETAIL";
export const GET_TRANSACTION_DETAIL = "GET_TRANSACTION_DETAIL";
export const UPDATE_NAME = "UPDATE_NAME";
export const UPDATE_USERNAME = "UPDATE_USERNAME";
export const UPDATE_EMAIL = "UPDATE_EMAIL";
export const UPDATE_PHONE = "UPDATE_PHONE";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export const UPDATE_BIO = "UPDATE_BIO";
export const EDIT_CARD_DETAILS = "EDIT_CARD_DETAILS";

//businessProfile
export const GET_BUSINESS_PROFILE = "GET_BUSINESS_PROFILE";

//Get_chart
export const GET_CHART_DETAIL = "GET_CHART_DETAIL";

//Plan
export const GET_PLAN = "GET_PLAN";
export const ADD_CREDIT_CARD = "ADD_CREDIT_CARD";

//LOADER
export const ENABLE_LOADER = "ENABLE_LOADER";
export const DISABLE_LOADER = "DISABLE_LOADER";
export const REFETCH_POSTS = "REFETCH_POSTS";

//APPOINTMENT
export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";
export const GET_QUESTION_DETAILS = "GET_QUESTION_DETAILS";

//ORDER
export const GET_ORDER = "GET_ORDER";
export const GET_ALL_ORDERS = "GET_ALL_ORDERS";
export const GET_ORDER_FOR_PAST_30_DAYS = "GET_ORDER_FOR_PAST_30_DAYS";
export const GET_EXPORT_ORDERS = "GET_EXPORT_ORDERS";
export const DELETE_ORDER = "DELETE_ORDER";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const SEND_MAIL = "SEND_MAIL";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const PRINT_RECEIPT = "PRINT_RECEIPT";
export const SAVEONLINEORDER_MESSAGE = "SAVEONLINEORDER_MESSAGE";
export const ENABLE_DISABLE_FORM = "ENABLE_DISABLE_FORM";
export const GET_FORM_DETAILS = "GET_FORM_DETAILS";
export const GET_BUSINESS_ORDER_NOTIFICATION_DETAILS =
  "GET_BUSINESS_ORDER_NOTIFICATION_DETAILS";
export const SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS =
  "SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS";
export const STRIPE_REFUND = "STRIPE_REFUND";
